import 'styled-components';

import { ITheme } from './styles';
export { styles } from './styles';

export { Box, ScrollableBox } from './components/containers';

export { Button } from './components/button';
export { Spin } from './components/spin';
export { ThemeProvider } from './components/themeProvider';
export { Checkbox } from './components/checkbox';
export { ErrorHint } from './components/errorHint';
export { Input, TextArea } from './components/input';
export { Text } from './components/text';
export { Tag } from './components/tag';
export { Select } from './components/select';
export { SelectMulti } from './components/selectMulti';
export { Item } from './components/item';
export { Image } from './components/image';

export { HoverTooltip, TooltipContent } from './components/hoverTooltip';

export { useDebouncedState, useForm, useOnScrollEnd } from './hooks';

declare module 'styled-components' {
  export interface DefaultTheme extends ITheme {}
}
